import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import LeadsCRM from "./leadschild/leadsCRM";
import ApprovedCRM from "./Approved/approvedCRM"
import AllocatedCRM from "./Allocated/allocatedCRM";
// import NDAaggrementPrimary from "./Aggrement & NDAs/ndaAggrementPrimary";
// import PrimaryHalaIndiaCertifcateForm from "./HalalCertificationForm/PrimaryHalaCertificateForm";
// import PrimaryServiceListing from "./service_Listing/PrimaryServiceListing";
// Company Detail Component
const CompanyDetail = () => (
  <Box p={2}>
    <Typography variant="h6" gutterBottom>
      Company Detail
    </Typography>
    <Typography>
      This is where the company details will be displayed.
    </Typography>
  </Box>
);

// Director Detail Component
const DirectorDetail = () => (
  <Box p={2}>
    <Typography variant="h6" gutterBottom>
      Director Detail
    </Typography>
    <Typography>
      This is where the director details will be displayed.
    </Typography>
  </Box>
);

// Main Tab Component
export default function PrimaryLeadCRM() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box  sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
        maxHeight: "100%",
        padding:2,
        height:"100%",
       
        overflowY: "auto",
        textAlign:"left",
        bgcolor:"#EDF2F9",
        // Custom scrollbar styles
        "&::-webkit-scrollbar": {
          width: "6px", // Width of the scrollbar
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1", // Track color
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888", // Thumb color
          borderRadius: "10px", // Optional rounded edges for the thumb
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555", // Thumb color on hover
        },
      }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"

        sx={{
          borderBottom: 2,
          paddingBottom:1,
          bgcolor:"white",
          width:"100%",
          borderColor: "divider",
          "& .MuiTab-root": { textTransform: "none", fontWeight: "500" },
        }}
      >
        <Tab label="Leads" />
        <Tab label="Approved" />
        <Tab label="Allocated" />
      
        
      </Tabs>

      {/* Content Area */}
      <Box mt={2} sx={{bgcolor:"white",width:"100%",height:"100%",my:0}}>
        {activeTab === 0 && <LeadsCRM />}
        {activeTab === 1 && <ApprovedCRM />}
        {activeTab === 2 && <AllocatedCRM />}
    
      </Box>
    </Box>
  );
}
